import { render, staticRenderFns } from "./updatePsw.vue?vue&type=template&id=3284697c&"
import script from "./updatePsw.vue?vue&type=script&lang=js&"
export * from "./updatePsw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports